const ItemEditableStatus = Object.freeze({
    IS_EDITABLE: 'isEditable',
    IS_EXPIRED: 'isExpired',
    IS_NOT_EDITABLE: 'isNotEditable',
    IS_NOT_EDITABLE_TYPE: 'isNotEditableType', // Not a ticket or a product
    IS_REDEEMED: 'isRedeemed',
    HAS_BOOKABLE_RESOURCES: 'hasBookableResources',
});

module.exports = ItemEditableStatus;
